import gsap from "gsap";
import ScrollSmoother from "gsap/ScrollSmoother";
import ScrollTrigger from "gsap/ScrollTrigger";
import { mapState, mapActions } from 'pinia';
import { setSmoother } from 'utils/ScrollSmootherInstance.js';
ScrollSmoother.isTouch = false;

gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

export default {
	data() {
		return {
			smoother: null,
			lastScrollPos: 0
		}
	},
	methods: {
		...mapActions(usePageAnimationStore, ["setScrollDirection"]),
		handleScrollUpdate() {
			if (!this.smoother) return;

			const currentScroll = this.smoother.scrollTop();

			if (currentScroll > this.lastScrollPos + 0.1) {
				this.setScrollDirection('down');
			} else if (currentScroll < this.lastScrollPos - 0.1) {
				this.setScrollDirection('up');
			}

			this.lastScrollPos = currentScroll;
		},
		initializeSmoother() {
			this.smoother = ScrollSmoother.create({
				wrapper: "#smooth-wrapper",
				content: "#smooth-content",
				smooth: 3,
				effects: true,
				smoothTouch: true,
				onUpdate: this.handleScrollUpdate,
				normalizeScroll: this.getIsMobileState ? true : false
			})
			setSmoother(this.smoother);
			this.smoother.paused(!this.getPageEnableScroll);
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.initializeSmoother();
		})
	},
	beforeUnmount() {
		if (this.smoother) {
			this.smoother.kill();
			this.smoother?.scrollTo?.(0, false);
			this.smoother = null;
			setSmoother(this.smoother);
		}
	},
	computed: {
		...mapState(useViewportStore, ["getIsMobileState"]),
		...mapState(usePageAnimationStore, ["getPageEnableScroll"]),
	},
	watch: {
		getIsMobileState() {
			this.initializeSmoother();
		},
		getPageEnableScroll(state) {
			if (this.smoother) {
				this.smoother.paused(!state);
			}
		}
	}
}
